<template>
  <v-row justify="center" class="mt-5">
    <v-col cols="3">
      <v-text-field label="รหัส นศ." v-model="student_id" outlined dense />
    </v-col>
    <v-col cols="9" class="d-flex justify-left">
      <span v-if="student_data.length != 0">
        <b>
          {{ student_data.prename_th }} {{ student_data.name_th }}
          {{ student_data.surname_th }}
        </b>
        <br /><b><u>ระดับ</u> :</b> {{ student_data.level_name_th }} <b><u>คณะ</u> :</b>
        {{ student_data.faculty_name }}
        <span style="color: blue; font-weight: bold"
          >currID : {{ student_data.curr_id }}</span
        >
        {{ student_data.curr_tname }} <br />
        <b><u>ปีรับเข้า</u> :</b> {{ student_data.admis_term }} /
        {{ student_data.admis_year }} <b><u>ประเภทรับเข้า</u> :</b>
        {{ student_study_admit_type }} <br />{{
          inter_student == "1" ? "นักศึกษาต่างชาติ" : "นักศึกษาไทย"
        }}
        <b><u>แผนการศึกษา</u> :</b> {{ student_data.study_plan_name_th }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import UserProvider from "@/services/user.provider";
import RefProvider from "@/services/ref.provider";
const userService = new UserProvider();
const refService = new RefProvider();
export default {
  name: "StudentInfo",
  data: () => ({
    student_id: "",
    student_data: [],
    student_study_admit_type: "",
    study_admit_types: [],
  }),

  methods: {
    get_student_data: async function () {
      this.student_data = [];
      let response = await userService
        .getStudentData(this.student_id)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });
      if (response) {
        this.student_data = response;
        let found = this.study_admit_types.find(
          (type) =>
            type.REGISTRAR_ADMIT_TYPE_ID === this.student_data.admis_type
        );
        if (found) {
          this.student_study_admit_type = found.STUDY_ADMIT_TYPE_NAME_TH;
        } else {
          this.student_study_admit_type = "";
        }
      }
    },
    async get_study_admit_type() {
      const response = await refService
        .getStudyAdmitTypeByLevel(2)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.study_admit_types = response;
    },
  },
  computed: {},
  watch: {
    student_id: {
      handler: function () {
        if (this.student_id.length === 8) {
          this.get_student_data();
        } else {
          this.student_data = [];
        }
      },
    },
  },
  created() {
    this.get_study_admit_type();
  },
};
</script>

<style scoped></style>
